import { render } from "./EditBaseResume.vue?vue&type=template&id=00d0f0ed&scoped=true"
import script from "./EditBaseResume.vue?vue&type=script&lang=js"
export * from "./EditBaseResume.vue?vue&type=script&lang=js"

import "./EditBaseResume.vue?vue&type=style&index=0&id=00d0f0ed&scoped=true&lang=css"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d0f0ed"]])

export default __exports__